import React, { useEffect, useState } from 'react';
import { 
  Container, 
  Box, 
  Typography, 
  IconButton,
  Paper,
  useTheme
} from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const testimonialsData = [
  { 
    name: 'Anonymous', 
    message: "I once booked an appointment, followed all the instructions given to me, and all I can say is—I highly recommend it!" 
  },
  { 
    name: 'Anonymous', 
    message: "During my final year, I fell ill and met her (she was my lecturer at the time). Thankfully, I followed all her instructions, and to my surprise, I recovered without taking any medication." 
  },
  { 
    name: 'Anonymous', 
    message: "She's a rare gem! 💎" 
  },
];

const Testimonials = () => {
   const theme = useTheme();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
        setIsTransitioning(false);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const handleIndicatorClick = (index) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 300);
  };

  return (
    <Container sx={{ marginTop: 5 }}>
      <Typography
          sx={{
              fontFamily: 'Fredoka One, sans-serif',
              color: 'grey.800',
              marginBottom: '20px',
              fontSize: '1.7rem',
          }}
      >
          Testimonials
      </Typography>

      <Paper 
        elevation={3} 
        sx={{ 
          p: 2,
          borderRadius: 2,
          border: `2px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[2],
        }}
      >
        <Box 
          sx={{
            opacity: isTransitioning ? 0 : 1,
            transition: 'opacity 0.3s ease-in-out'
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <FormatQuoteIcon sx={{ fontSize: 60, color: 'primary.main' }} />
          </Box>
          
          <Typography 
            align="center" 
            sx={{ mb: 2, px: 2 }}
          >
            {testimonialsData[currentIndex].message}
          </Typography>
          
          <Box sx={{ textAlign: 'center' }}>
            <Typography 
              variant="subtitle1" 
              component="h3" 
              sx={{ fontWeight: 'bold', mb: 1 }}
            >
              {testimonialsData[currentIndex].name}
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mt: 3, 
          gap: 1 
        }}
      >
        {testimonialsData.map((_, index) => (
          <Box
            key={index}
            onClick={() => handleIndicatorClick(index)}
            sx={{
              width: currentIndex === index ? 32 : 12,
              height: 12,
              borderRadius: 6,
              bgcolor: currentIndex === index ? 'primary.main' : 'grey.300',
              cursor: 'pointer',
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                bgcolor: currentIndex === index ? 'primary.main' : 'grey.400'
              }
            }}
          />
        ))}
      </Box>
    </Container>
  );
};

export default Testimonials;